import { render, staticRenderFns } from "./ModalTaskInfo.vue?vue&type=template&id=4562b5af&scoped=true"
import script from "./ModalTaskInfo.vue?vue&type=script&lang=js"
export * from "./ModalTaskInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskInfo.vue?vue&type=style&index=0&id=4562b5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562b5af",
  null
  
)

export default component.exports